import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Pastikan path '../context/AuthContext' benar
import './Login.css';

function Login() {
  const [email, setEmail] = useState(''); // Ganti username menjadi email
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (event) => { // Jadikan async
    event.preventDefault();
    setError('');

    // Panggil fungsi login dari context yang sudah diupdate
    const result = await auth.login(email, password); // Gunakan email

    if (result.success) {
      navigate(from, { replace: true });
    } else {

      setError(result.message || 'Email atau password salah!');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Admin Login</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label htmlFor="email">Email:</label> {/* Ganti username menjadi email */}
          <input
            type="email" // Ganti tipe menjadi email
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
        {/* Hapus hint jika tidak relevan dengan API Anda */}
        {/* <p className="hint">Hint: Coba username 'admin' dan password 'password'</p> */}
      </form>
    </div>
  );
}

export default Login;